import http from '../../../../../http/base';
import { API_PATHS } from '../../../../../http/configs';

export function getEquipmentAndFacilitiesPolicies(documentAgreementVersion, programPaymentType, facilityAFNumber) {
    return http.get(API_PATHS.getEquipmentAndFacilitiesPolicies, { params: { documentAgreementVersion, programPaymentType, facilityAFNumber } });
};